import React from 'react'

import DynamicMapMobile from './dynamicMapMobile.component'

import SidebarMapsMobile from './sidebar.component'

interface Props {
  isLocation: boolean,
  locationData: any,
  colorsData: any
}

interface State {
  filteredRoute: any,
  selectedPOI: any,
  routesActive: boolean,
  POISActive: boolean,
  
}

class MapContainerMobile extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      filteredRoute: "",
      selectedPOI: {},
      routesActive: true,
      POISActive: false
      
    }
  }

  handleFilteredRoute = (route: string) => {
    this.setState({
        filteredRoute: route,
        routesActive: true,
        POISActive: false
    })
}

handleSelectPOI = (poi: any) => {
    this.setState({
        selectedPOI: poi,
        routesActive: false,
        POISActive: true
    })
}

componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
  if(this.props.isLocation !== prevProps.isLocation && this.props.isLocation){
      this.setState({
          POISActive: false,
          selectedPOI: '',
          routesActive: true,
          filteredRoute: ''
      })
  }
}

  render(): React.ReactNode {
      return(
        <div className={this.props.isLocation ? 'map-container-main-mobile fade-in':'map-container-main-mobile fade-out'}>
          {
            this.props.locationData ?
              <DynamicMapMobile
                  locationData={this.props.locationData}
                  filteredRoute = {this.state.filteredRoute}
                  selectedPOI = {this.state.selectedPOI}
                  colorsData={this.props.colorsData}
                  routesActive = {this.state.routesActive}
                  POISActive = {this.state.POISActive}
                  isLocation = {this.props.isLocation}
              />:null
          }
          {
            <SidebarMapsMobile
              logoPuntos={this.props.locationData.POIS_icon}
              logoVias={this.props.locationData.routes_icon}
              locationData={this.props.locationData}
              colorsData={this.props.colorsData}
              handleFilteredRoute={this.handleFilteredRoute}
              handleSelectPOI = {this.handleSelectPOI}
              routesActive = {this.state.routesActive}
              POISActive = {this.state.POISActive}
            />
          }
        </div>
      )
  }
}

export default MapContainerMobile